import React, { Component } from 'react';
import ArrowButton from './NavigationButtons/ArrowButton';
import ImageButton from './NavigationButtons/ImageButton';
import prevBtn from '../../../../images/back-btn.png';
import nextBtn from '../../../../images/next-btn.png';
import exitBtn from '../../../../images/exit-vr-btn.png';
import pauseBtn from '../../../../images/pause_vr.png';
import playBtn from '../../../../images/play_arrow_vr.png';

class VRControls extends Component {
  state = {
    exitCtrl: true,
    navCtrl: true,
    showTooltips: true,
    showStopMedia: false,
    audioPlaying: false,
  };

  componentDidMount() {
    const { initialView } = this.props;
    this.setAudio();
    this.vrControls = document.getElementById('vr-controls');
    initialView.rotation &&
      this.vrControls.setAttribute('rotation', { y: initialView.rotation.y });
  }

  componentDidUpdate(prevProps, prevState) {
    const { activeStop, isMainMediaPlaying } = this.props;
    if (prevProps.activeStop !== activeStop) {
      this.setAudio();
      this.setState({ exitCtrl: true, navCtrl: true, showTooltips: false });
    }

    if (prevProps.isMainMediaPlaying && !isMainMediaPlaying) {
      this.setState({ audioPlaying: false });
    }
  }

  componentWillUnmount() {
    if (this.audio) {
      this.audio.removeEventListener('play', this.setAudioPlaying);
      this.audio.removeEventListener('ended', this.setAudioPlaying);
    }
  }

  setAudio = () => {
    this.audio = document.getElementById('audio');
    if (this.audio) {
      this.setState({ audioPlaying: !this.audio.paused });
      this.audio.addEventListener('play', this.setAudioPlaying);
      this.audio.addEventListener('ended', this.setAudioPlaying);
    }
  };

  setAudioPlaying = ({ type }) => {
    const { toggleMainMediaStatus } = this.props;
    const audioPlaying = type === 'play';

    if (audioPlaying) {
      toggleMainMediaStatus(true);
    }
    this.setState({ audioPlaying });
  };

  toggleExitCtrl = () => {
    this.setState(state => ({
      exitCtrl: !state.exitCtrl,
      showTooltips: false,
    }));
  };

  toggleNavCtrl = () => {
    this.setState(state => ({ navCtrl: !state.navCtrl, showTooltips: false }));
  };

  handleVideoToggle = () => {
    if (typeof this.props.handleVideoPlay === 'function') {
      this.props.handleVideoPlay();
    }
  };

  handleAudioToggle = () => {
    if (!this.audio) return;
    if (this.audio.paused) {
      this.audio.play();
    } else {
      this.audio.pause();
    }
    this.setState(({ audioPlaying }) => ({ audioPlaying: !audioPlaying }));
  };

  render() {
    const {
      changeStop,
      activeStop,
      currentStop,
      toggleVR,
      videoIsPlaying,
      video,
    } = this.props;
    const { audioPlaying } = this.state;

    return (
      <a-entity id="vr-controls">
        <ImageButton
          id="vr-exit"
          height="1"
          width="2"
          position="0 3 -6"
          handleClick={() => toggleVR(false)}
          src={exitBtn}
        />
        <a-text
          value={currentStop.name}
          align="center"
          color="#fff"
          position="0 -1.6 -3"
        />
        <ArrowButton
          class="clickable"
          id="prev-btn"
          src={prevBtn}
          height="0.5"
          width="1.25"
          position="-1.5 -4 -6"
          handleClick={changeStop}
          activeStop={activeStop - 1}
          currentStop={currentStop}
        />
        {video && (
          <ImageButton
            id="video-play-btn"
            src={videoIsPlaying ? pauseBtn : playBtn}
            label={videoIsPlaying ? 'Pause Video' : 'Play Video'}
            height="1"
            width="1"
            position="0 -1 -6"
            handleClick={this.handleVideoToggle}
          />
        )}
        {this.audio && (
          <ImageButton
            id="audio-play-btn"
            src={audioPlaying ? pauseBtn : playBtn}
            height="0.5"
            label={audioPlaying ? 'Pause Audio' : 'Play Audio'}
            width="0.5"
            position="0 -4 -6"
            handleClick={this.handleAudioToggle}
          />
        )}
        <ArrowButton
          class="clickable"
          id="next-btn"
          src={nextBtn}
          height="0.5"
          width="1.25"
          position="1.5 -4 -6"
          handleClick={changeStop}
          activeStop={activeStop + 1}
          currentStop={currentStop}
        />
      </a-entity>
    );
  }
}

export default VRControls;
